module.exports = require("chained-function");


//////////////////
// WEBPACK FOOTER
// external "chained-function"
// module id = 3
// module chunks = 0